// TODO：エラーハンドリングを考慮した実装を考える

import { initializeApp } from "firebase/app";
import {
  getAuth,
  browserSessionPersistence,
  setPersistence,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  updatePassword,
} from "firebase/auth";
import { firebaseConfig } from "../../constants/firebase";

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// 本当にこの処理で良いのか？
export const signUp = async (email: string, password: string) => {
  try {
    await createUserWithEmailAndPassword(auth, email, password);
    await setPersistence(auth, browserSessionPersistence);
  } catch (error) {
    console.error("signUp error");
  }
};

// 本当にこの処理で良いのか？
export const logIn = async (email: string, password: string) => {
  await signInWithEmailAndPassword(auth, email, password);
  await setPersistence(auth, browserSessionPersistence);
};

// 本当にこの処理で良いのか？
export const logOut = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error("logOut error");
  }
};

// 本当にこの処理で良いのか？
export const passwordReset = async (
  email: string,
  currentPassword: string,
  newPassword: string,
) => {
  try {
    // パスワードリセット前にログイン(ターゲットユーザー取得)
    const UserCredentials = await signInWithEmailAndPassword(
      auth,
      email,
      currentPassword,
    );

    if (!UserCredentials.user) {
      throw new Error("Invalid email or password");
    }
    await updatePassword(UserCredentials.user, newPassword); // パスワードリセット
    await signOut(auth); // パスワードリセット後にログアウト
  } catch (error) {
    console.error("passwordReset error");
  }
};
